/* eslint-disable no-unused-vars */
/* eslint-disable consistent-return */
const throttled = {};
export default (store) => (next) => (action) => {
    // Guard against null/undefined actions or non-action objects (like Promises)
    if (!action || typeof action !== 'object' || !action.type) {
        return next(action);
    }

    const time = action.meta && action.meta.throttle;
    if (!time) { return next(action); }
    if (throttled[action.type]) {
        clearTimeout(throttled[action.type]);
    }
    throttled[action.type] = setTimeout(() => {
        next(action);
    }, time);
};
